<span
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [iuValidationDisplay]="data?.hasValidation"
  [iuValidationDisplay.datacontainer]="this"
  [iuValidationDisplay.iconIdx]="1"
  [iuValidationDisplay.inputSelector]="'div.input-number-body'"
  [iuValidationDisplay.valid]="isValid()"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss">
  @if (this.inputRef && isLabelDisplay && label !== undefined && label !== null && label.trim().length > 0) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      {{ label }}
    </label>
  }
  <div class="input-number-body">
    @if (!multiple) {
      <input
        #input
        autocomplete="off"
        class="iu-number-input"
        data-cy="input-text"
        onkeydown="event.keyCode !== 69"
        type="text"
        [attr.data-cy-columnName]="data ? data.columnName : columnName"
        [attr.value]="fieldValue"
        lang="{{ lang }}"
        [max]="this.max"
        [min]="this.min"
        [ngClass]="[
          hasConflict ? 'iu-field-conflict-text' : '',
          'quantity',
          'ui-corner-all input-field p-inputtext',
          mandatoryCss || '',
        ]"
        [ngModel]="fieldValue | number: numberFormat : lang"
        [ngModelOptions]="{ updateOn: 'blur' }"
        placeholder="{{ placeHolder }}"
        [readonly]="isReadOnly ? 'disabled' : null"
        [step]="fieldStep"
        [style.font-size]="overridedCSS?.inputFontSize"
        [style.height]="overridedCSS?.inputHeight"
        [tabindex]="isReadOnly ? '-1' : null"
        (blur)="inputBlur.emit($event)"
        (change)="dataChange(_parseFloat(input.value))"
        (contextmenu)="onContextMenu($event)"
        (keydown.enter)="enterKey.emit($any($event))"
        (keypress)="isNumber($event)"
        (ngModelChange)="fieldValue = $event"
        (press)="onContextMenu($any($event))"
        (wheel)="OnWheel($event)" />
    } @else {
      <iu-input-chips-ui
        #inputChips
        [addOnBlur]="true"
        [addOnEnter]="true"
        [addOnSpace]="true"
        [columnName]="data ? data.columnName : columnName"
        [cssClass]="'iu-number-input'"
        [editOnBackspace]="true"
        [inputType]="'number'"
        [isInUniversalFilter]="isInUniversalFilter"
        [isLabelDisplay]="false"
        [matchPattern]="regexNB"
        [(fieldValue)]="fieldValue"
        (fieldValueChange)="dataChange($event)" />
    }
    @if (!this.isCurrencyDisplay) {
      <i
        #currencySpan
        aria-hidden="true"
        class="icon-number iconCurrency"
        [attr.disabled]="isReadOnly ? 'disabled' : null"
        [style.height]="overridedCSS?.inputHeight">
      </i>
    } @else {
      <i #currencySpan class="iconCurrency" [attr.disabled]="isReadOnly ? 'disabled' : null">{{ this.currency }}</i>
    }
  </div>
  @if (hasConflict && dataStored) {
    <i
      #spanInput
      aria-hidden="true"
      class="rtconflict fas fa-exclamation-triangle iconClass"
      (click)="showConflictPanel($event)"></i>
  }
  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>

<iu-prime-overlay #opConflict>
  <a class="data-conflict" (click)="chooseData($event, (dataStored?.data)[data.columnName], true); opConflict.hide()">{{
    (dataStored?.data)[data.columnName]
  }}</a>
  |
  <a class="data-conflict" (click)="chooseData($event, conflictedData, false); opConflict.hide()">{{
    conflictedData
  }}</a>
</iu-prime-overlay>
